import { sha256Hex } from './sha256';

/** UI disambiguation tag — first three hex chars of sha256(wsUrl). */
export function computeDisplayChecksum(wsUrl: string): string {
  return sha256Hex(wsUrl).slice(0, 3);
}
